<template>
  <div class="pageMyReservation">
    <h2>{{ $t("pages.wording.reserve") }}</h2>
    <!--我的預約單-->
    <el-form label-width="150px">
      <div class="boxContain c-form searchBar">
        <el-row :gutter="24">
          <el-col :span="9">
            <el-form-item :label="$t('pages.wording.reserveNo')"
              ><!--deltaContactName-->
              <el-input :placeholder="$t('pages.wording.queryReserveNum')" v-model="searchForm.reserveNo"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item :label="$t('pages.wording.reserveDate')"
              ><!--deltaContactName-->
              <el-date-picker
                v-model="searchForm.reserveArriveTime"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button class="blue-button" @click="searchTable()" type="primary">{{
              $t("pages.button.search")
            }}</el-button>
          </el-col>
        </el-row>
      </div>
      <!--boxContain-->
    </el-form>
    <div class="boxContain c-table">
      <el-tabs v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="preProcess" name="Pending">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.reserve") }}({{
              this.reserveTablePendingCount
            }})</span
          ><!--待處理-->
          <div class="s-table">
            <template>
              <el-table
                :data="preProcessNewTableData"
                v-loading="tableIsLoading"
                border
                style="width: 100%"
                height="450px"
                @current-change="applyReserveForm"
              >
                <el-table-column :label="$t('pages.wording.edit')" width="60"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button type="text" size="medium">
                      <i class="el-icon-edit"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column
                  prop="releaseOrder"
                  :label="$t('pages.wording.releaseOrder')"
                  align="center"
                  width="120"
                >
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                  >
                    <span class="releaseBtn" @click.stop="openReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="100"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  sortable
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveTime')"
                  width="200"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.reserveFactory')" width="120">
                </el-table-column
                ><!--廠別-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="140">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達接洽人-->

                <el-table-column prop="showStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="applyDate" :label="$t('pages.wording.applyDate')" width="130">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.preProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="reserveTablePendingCount"
              @current-change="changePagePreProcessTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
        <el-tab-pane label="inProcess" name="Process">
          <span slot="label"
            ><i class="el-icon-receiving"></i>{{ $t("pages.wording.inProccess") }}({{
              this.reserveTableProcessCount
            }})</span
          ><!--處理中-->
          <div class="s-table">
            <template>
              <el-table
                :data="inProcessNewTableData"
                v-loading="tableIsLoading"
                border
                style="width: 100%"
                height="450px"
                @current-change="applyReserveInfo"
              >
                <el-table-column :label="$t('pages.wording.edit')" width="60"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <!--<el-button v-if="scope.row.reserveStatus == 'entering'" @click="" type="text" size="medium">
											<i class="el-icon-edit"></i>
										</el-button>-->
                    <el-button @click="" type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column
                  prop="releaseOrder"
                  :label="$t('pages.wording.releaseOrder')"
                  align="center"
                  width="120"
                >
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                  >
                    <span class="releaseBtn" @click.stop="openReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="100"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  sortable
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveTime')"
                  width="200"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.reserveFactory')" width="120">
                </el-table-column
                ><!--廠別-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="140">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達接洽人-->

                <el-table-column prop="showStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="applyDate" :label="$t('pages.wording.applyDate')" width="130">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.inProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="reserveTableProcessCount"
              @current-change="changePageInProcessTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
        <el-tab-pane label="finish" name="Finish">
          <span slot="label"
            ><i class="el-icon-check"></i>{{ $t("pages.wording.finish") }}({{ this.reserveTableFinishCount }})</span
          ><!--已完成-->
          <div class="s-table">
            <template>
              <el-table
                :data="finishNewTableData"
                v-loading="tableIsLoading"
                border
                style="width: 100%"
                height="450px"
                @current-change="applyReserveInfo"
              >
                <el-table-column :label="$t('pages.wording.edit')" width="60"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button @click="" type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveNo')" width="130"> </el-table-column
                ><!--單號-->
                <el-table-column
                  prop="releaseOrder"
                  :label="$t('pages.wording.releaseOrder')"
                  align="center"
                  width="130"
                >
                  <template
                    slot-scope="scope"
                    v-if="scope.row.reserveType == 'ERP' || scope.row.reserveType == 'ERP_ONE'"
                    align="center"
                  >
                    <span class="releaseBtn" @click.stop="openReleaseOrderList(scope.row)">{{
                      $t("pages.wording.releaseOrder")
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" :label="$t('pages.wording.oaCode')" width="100"> </el-table-column
                ><!--OA Code-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="150"> </el-table-column
                ><!--公司名稱-->
                <el-table-column
                  sortable
                  prop="reserveArriveDate"
                  :label="$t('pages.wording.reserveArriveTime')"
                  width="200"
                  ><!--預約進廠時間-->
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("DateTime", scope.row.reserveArriveDatetime) }}
                  </template>
                </el-table-column>
                <el-table-column prop="reserveFactory" :label="$t('pages.wording.reserveFactory')" width="120">
                </el-table-column
                ><!--廠別-->
                <el-table-column prop="enterReason" :label="$t('pages.wording.enterReason')" width="140">
                  <template slot-scope="scope" v-if="scope.row.reserveArriveDatetime != null">
                    {{ $store.getters.getSysCodeText("enterReason", scope.row.enterReason) }}
                  </template></el-table-column
                ><!--入廠事由-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達接洽人-->

                <el-table-column prop="showStatus" :label="$t('pages.wording.reserveStatus')" width="150"
                  ><!--狀態-->
                  <template slot-scope="scope">
                    {{ $t("reserve.status." + scope.row.reserveStatus) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="applyDate" :label="$t('pages.wording.applyDate')" width="130">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--填單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.finishTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="reserveTableFinishCount"
              @current-change="changePageFinishTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table-->
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="$t('pages.wording.releaseOrder')" :visible.sync="dialog.showreleaseOrder" width="50%">
      <el-row>
        <el-col :span="1"><p></p></el-col>
        <el-table
          :data="dialog.releasTableData"
          style="width: 92%"
          height="300px"
          @current-change="goReleaseInfoPage"
          :default-sort="{ prop: 'saleDate', order: 'descending' }"
        >
          <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseNo')"> </el-table-column>
          <el-table-column prop="SO" label="SO No." width="120"> </el-table-column>
          <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="120"> </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialog.showreleaseOrder = false">{{ $t("pages.button.close") }}</el-button>
        </span>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { utils } from "@/utils/utils.js"
import { api } from "@/utils/api.js"
export default {
  name: "NewPageMyReservation",
  data() {
    return {
      activeName: "Pending",
      alertMessageCb: {},
      alertMessage: {},
      tableIsLoading: false,
      preProcessTableData: [],
      preProcessNewTableData: [],
      inProcessTableData: [],
      inProcessNewTableData: [],
      finishTableData: [],
      finishNewTableData: [],
      searchForm: {
        reserveArriveTime: [],
        reserveNo: "",
      },
      dialog: {
        showreleaseOrder: false,
        releasTableData: [],
        tableIsLoading: false,
      },
      reserveTablePendingCount: 0,
      reserveTableProcessCount: 0,
      reserveTableFinishCount: 0,
      pages: {
        pageCount: this.$global.pageCount,
        pageSize: this.$global.pageSize,
        preProcessTablePage: {
          pageCurrent: 1,
        },
        inProcessTablePage: {
          pageCurrent: 1,
        },
        finishTablePage: {
          pageCurrent: 1,
        },
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserLoginData"]),
    async init() {
      this.initQueryParams()
      this.getReserveTableCountInfo()
      this.preProcessNewTableData = await this.getReserveTableData("Pending", 1, this.pages.pageSize)
    },
    initQueryParams() {
      let monthDate = utils.getMonthFirstLastDate()
      let firstDate = utils.getDateTime(monthDate[0])
      let lastDate = utils.getDateTime(monthDate[1])
      let firstDatetime = utils.getISOString(firstDate[0] + " " + firstDate[1])
      let lastDatetime = utils.getISOString(lastDate[0] + " " + lastDate[1])
      //查詢預設
      this.searchForm.reserveArriveTime = [
        utils.parseISOStringToDate(firstDatetime),
        utils.parseISOStringToDate(lastDatetime),
      ]
    },
    tabClick(tab, event) {
      this.getReserveTableByTab()
    },
    /***************-PAGING-***************/
    async changePagePreProcessTable(page) {
      this.preProcessNewTableData = await this.getReserveTableData("Pending", page, this.pages.pageSize)
    },
    async changePageInProcessTable(page) {
      this.inProcessNewTableData = await this.getReserveTableData("Process", page, this.pages.pageSize)
    },
    async changePageFinishTable(page) {
      this.finishNewTableData = await this.getReserveTableData("Finish", page, this.pages.pageSize)
    },
    async getReserveTableCountInfo() {
      const params = {
        ReserveNo: this.searchForm.reserveNo,
        ReserveArriveTimeStart: "",
        ReserveArriveTimeEnd: "",
      }
      if (this.searchForm.reserveArriveTime != null && this.searchForm.reserveArriveTime.length != 0) {
        params.ReserveArriveTimeStart = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.reserveArriveTime[0]))[0] + " 00:00"
        )
        params.ReserveArriveTimeEnd = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.reserveArriveTime[1]))[0] + " 23:59"
        )
      }
      try {
        const { data: reserveTableCountData } = await api.apiGetReserveTableCountForVendor(params)
        this.reserveTablePendingCount = reserveTableCountData.hasOwnProperty("Pending")
          ? reserveTableCountData.Pending
          : 0
        this.reserveTableProcessCount = reserveTableCountData.hasOwnProperty("Process")
          ? reserveTableCountData.Process
          : 0
        this.reserveTableFinishCount = reserveTableCountData.hasOwnProperty("Finish") ? reserveTableCountData.Finish : 0
      } catch (error) {
        this.reserveTablePendingCount = 0
        this.reserveTableProcessCount = 0
        this.reserveTableFinishCount = 0
      }
    },
    async getReserveTableData(queryType, pageNumber, pageSize) {
      try {
        this.tableIsLoading = true
        const params = {
          ReserveNo: this.searchForm.reserveNo,
          ReserveArriveTimeStart: "",
          ReserveArriveTimeEnd: "",
          PageNumber: pageNumber,
          PageSize: pageSize,
          DataType: queryType,
        }
        if (this.searchForm.reserveArriveTime != null && this.searchForm.reserveArriveTime.length != 0) {
          params.ReserveArriveTimeStart = utils.getISOString(
            utils.getDateTime(new Date(this.searchForm.reserveArriveTime[0]))[0] + " 00:00"
          )
          params.ReserveArriveTimeEnd = utils.getISOString(
            utils.getDateTime(new Date(this.searchForm.reserveArriveTime[1]))[0] + " 23:59"
          )
        }
        const { data } = await api.apiGetReserveTableForVendor(params)
        this.tableIsLoading = false
        return data
      } catch (error) {
        this.tableIsLoading = false
        return []
      }
    },
    searchTable() {
      this.getReserveTableCountInfo()
      this.getReserveTableByTab()
    },
    async getReserveTableByTab() {
      switch (this.activeName) {
        case "Pending":
          this.preProcessNewTableData = await this.getReserveTableData("Pending", 1, this.pages.pageSize)
        case "Process":
          this.inProcessNewTableData = await this.getReserveTableData("Process", 1, this.pages.pageSize)
        case "Finish":
          this.finishNewTableData = await this.getReserveTableData("Finish", 1, this.pages.pageSize)
      }
    },
    applyReserveCheck(val) {
      if (val.reserveStatus == "entering") this.applyReserveForm(val)
      else this.applyReserveInfo(val)
    },
    applyReserveForm(val) {
      event.preventDefault()
      this.$router.push({
        name: "PageMyReservationForm",
        params: val,
      })
    },
    applyReserveInfo(val) {
      this.$router.push({
        name: "PageMyReservationInfo",
        params: val,
      })
    },
    goReleaseInfoPage(val) {
      this.$router.push({
        name: "PageVendorReleaseOrderInfo",
        params: val,
      })
    },
    async openReleaseOrderList(row) {
      try {
        const params = {
          reserveNo: row.reserveNo,
        }
        this.dialog.showreleaseOrder = true
        this.dialog.tableIsLoading = true
        const { data: releaseData } = await api.apiGetVendorReleaseTable(params)
        this.dialog.releasTableData = releaseData
        this.dialog.tableIsLoading = false
      } catch (error) {
        this.dialog.releasTableData = []
        this.dialog.tableIsLoading = false
      }
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {
    "$store.getters.alertMessage": function (val) {
      var code = val.code
      var message = val.message
      var cb = val.cb
      var title = code == 0 ? "Success" : "FAIL"

      utils.alertMessage(this, code, message, title, cb)
    },
  },
}
</script>

<style>
.c-table {
  position: relative;
}
.c-table .el-tabs__item {
  font-size: 14px;
  font-weight: 500;
  color: #dceaf8;
  height: 50px;
  line-height: 50px;
}
.c-table .el-tabs__item i {
  margin-right: 10px;
  font-size: 20px;
}
.c-table .el-tabs__header {
  background: #00a0e9;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  margin: 0px;
}
.c-table .el-tabs__nav {
  margin-left: 20px;
}
.c-table .el-tabs__item.is-active {
  color: #fff;
}
.c-table .el-tabs__nav-wrap::after {
  background-color: #002752;
}
.c-table .el-tabs__active-bar {
  width: 120px;
  background-color: #fff;
}
.c-table .el-table th {
  background: #f5f5f5;
}
.c-table .el-button--medium {
  font-size: 17px;
}
.el-pagination {
  text-align: right;
}
.c-table .el-table__fixed-right-patch {
  background: #f5f5f5;
}
.c-table .el-dialog,
.c-table .el-pager li,
.c-table .el-pagination .btn-next,
.c-table .el-pagination .btn-prev {
  background: none;
}
.c-table-top-right-btn .el-button {
  position: absolute;
  top: 4px;
  right: 10px;
  z-index: 99;
}

h2 {
  margin: 0 0 2rem;
}
</style>
